module.exports = __webpack_public_path__ + "static/media/Human_ZG4577-Edit_720.275bfd70.jpeg";